export const messages = {
  en: {
    historyFeeDetailImport: {
      assetInfo: 'Asset Information',
      feeObject: 'Fee Object',
      selectFeeObject: 'Required, please select fee object',
      house: 'House',
      car: 'Car',
      selectFile: 'Select File',
      requiredFile: 'Required, please select data file',
      clickUpload: 'Click to upload',
      description: 'Description',
      importTip: 'Note: This is for importing historical payment data from previous property systems to facilitate future accounting checks. It should only be used during property data initialization. Please carefully check the data before importing. Once imported, payment history cannot be deleted from the frontend and can only be removed by engineers from the database.',
      import: 'Import',
      houseTemplate: 'House Template',
      carTemplate: 'Car Template',
      fileRequired: 'File is required',
      invalidFileType: 'Invalid file type, only Excel files are allowed',
      fileSizeLimit: 'File size cannot exceed 10MB',
      generationMode: 'Generation Mode',
      periodicMode: 'Periodic Mode',
      billMode: 'Bill Mode',
      periodicTip: 'Create one continuous fee record, auto-generate arrears for unpaid periods',
      billTip: 'Split into monthly one-time fees, each month as independent bill (generates arrears for unpaid months)',
      arrearsDeadline: 'Arrears Deadline',
      arrearsDeadlinePlaceholder: 'Select arrears date, e.g. 2026-12-31',
      arrearsDeadlineTip: 'Future months with no payment will be generated as arrears. Specify fixed monthly amount in Excel column "生成欠费按多少元一月", or leave blank to use average (total ÷ paid months)',
      importSuccess: 'Import successful',
      importError: 'Import failed',
      requiredSelect: 'Required, please select',
      skipArrears: 'Skip Arrears (Only Import Payment Records)',
      mergeMode: 'Smart Merge (Utilities)',
      mergeModeTip: 'Find existing fee by same month, compare amounts, keep already-paid and update receivable'
    }
  },
  zh: {
    historyFeeDetailImport: {
      assetInfo: '资产信息',
      feeObject: '费用对象',
      selectFeeObject: '必填，请选择费用对象',
      house: '房屋',
      car: '车辆',
      selectFile: '选择文件',
      requiredFile: '必填，请选择数据文件',
      clickUpload: '点击上传',
      description: '说明',
      importTip: '请注意，这里是为了将物业之前系统缴费历史数据导入，方便物业后期查账使用，只有在物业数据初始化时使用，导入前请仔细检查数据，一旦导入前台无法删除缴费历史，只有工程师从数据库删除',
      import: '导入',
      houseTemplate: '房屋模板',
      carTemplate: '车辆模板',
      fileRequired: '文件不能为空',
      invalidFileType: '不是有效的Excel格式',
      fileSizeLimit: 'Excel文件大小不能超过10M',
      generationMode: '生成模式',
      periodicMode: '周期性模式',
      billMode: '账单模式',
      periodicTip: '一条费用记录自动生成未缴周期欠费',
      billTip: '每月独立一条一次性费用，按账单显示（未缴月份生成欠费）',
      arrearsDeadline: '欠费截至日期',
      arrearsDeadlinePlaceholder: '选择欠费截至日期，如 2026-12-31',
      arrearsDeadlineTip: '缴费截止月之后到该日期的月份，将生成欠费。可在Excel模板"生成欠费按多少元一月"列指定固定月金额，不填则按平均值（合计金额÷已缴费月数）',
      importSuccess: '处理成功',
      importError: '导入失败',
      requiredSelect: '必填，请选择',
      skipArrears: '不导入欠费信息（只导入缴费记录）',
      mergeMode: '智能合并（公摊/水电费专用）',
      mergeModeTip: '按同月份查找已有费用，比较金额，保留已收金额，更新应收金额'
    }
  }
}